var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectronics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5088 5H5.49123C5.36095 5 5.236 5.05175 5.14388 5.14388C5.05175 5.236 5 5.36095 5 5.49123V18.5088C5 18.6391 5.05175 18.764 5.14388 18.8561C5.236 18.9482 5.36095 19 5.49123 19H18.5088C18.6391 19 18.764 18.9482 18.8561 18.8561C18.9482 18.764 19 18.6391 19 18.5088V5.49123C19 5.36095 18.9482 5.236 18.8561 5.14388C18.764 5.05175 18.6391 5 18.5088 5ZM18.5088 5.49123V7.25154H5.49123V5.49123H18.5088ZM5.49123 18.5088V7.74277H18.5088V18.5088H5.49123Z",
    fill: "#240b3b",
    stroke: "#240b3b",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18118 10.9524L14.8193 10.9524C14.9455 10.9524 15.0479 11.0547 15.0479 11.181L15.0479 14.5333C15.0479 14.6596 14.9455 14.7619 14.8193 14.7619L9.18118 14.7619C9.05494 14.7619 8.95261 14.6596 8.95261 14.5333L8.95261 11.181C8.95261 11.0547 9.05494 10.9524 9.18118 10.9524Z",
    stroke: "#240b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95215 13.6191L7.99977 13.6191",
    stroke: "#240b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95215 12.0952L7.99977 12.0952",
    stroke: "#240b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0476 13.6191L16 13.6191",
    stroke: "#240b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0476 12.0952L16 12.0952",
    stroke: "#240b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.9524L12 10",
    stroke: "#240b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.7143L12 14.762",
    stroke: "#240b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0952 10.9524L14.0952 10",
    stroke: "#240b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0952 15.7143L14.0952 14.762",
    stroke: "#240b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90479 10.9524L9.90479 10",
    stroke: "#240b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90479 15.7143L9.90479 14.762",
    stroke: "#240b3b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronics);
export default __webpack_public_path__ + "static/media/electronics.fefa1226ef3e819ebad1dc64506fdd62.svg";
export { ForwardRef as ReactComponent };